export const INVOICE_LINE_DESCRIPTION_CONTENT_CHARACTER_LIMIT = 1000
